import {
  APIApartmentFull,
  APIApartmentItemLikable,
  APINotificationItem,
  APIFilterNotificationItem,
  MarketTypes,
} from './types';
import { formatApartmentTitle, formatNullishValue } from 'lib/utils';

export const transformApartmentItem = (a: APIApartmentItemLikable) => {
  return {
    id: a.id,
    area: a.areaInSqM,
    rooms: a.roomCount,
    price: a.price,
    isFavorite: a.isFavorite,
    squarePrice: ~~a.pricePerSqM,
    housingEstate: formatNullishValue(a.apartmentComplexTitle),
    floor: { floor: a.floor, total: a.floorCount },
    image: a.planImage ?? a.attachment ?? undefined,
    notificationEnabled: a.notificationEnabled,
    isSavedInTemporaryFiles: a?.isSavedInTemporaryFiles,
    hiddenUntil: a.hiddenUntil,
    availabilityStatus: a?.availabilityStatus,
    marketType: a?.marketType,
    buildingTitle: a?.buildingTitle,
  };
};

export const transformTemporaryItem = (a: any) => {
  return {
    id: a?.facility?.id,
    area: a?.facility?.plan?.areaInSqM ?? 0,
    price: a?.facility?.price,
    isSavedInTemporaryFiles: a?.isSavedInTemporaryFiles,
    housingEstate: formatNullishValue(a?.facility?.title),
    floor: { floor: a?.facility?.floor },
    image: a?.facility?.plan?.media?.url ?? undefined,
    hiddenUntil: a.facility?.hiddenUntil,
    marketType: a.facility?.marketType,
  };
};

export const transformNotificationItem = (a: APINotificationItem) => {
  return {
    notification: {
      id: a.notification?.id,
      isEnabled: a.notification?.isEnabled,
    },
    id: a?.id,
    area: a.areaInSqM,
    rooms: a.roomCount,
    price: a.price,
    isFavorite: a.isFavorite,
    squarePrice: ~~a.pricePerSqM,
    housingEstate: formatNullishValue(a.apartmentComplexTitle),
    floor: { floor: a.floor, total: a.floorCount },
    image: a.planImage ?? undefined,
    notificationEnabled: a.notificationEnabled,
    marketTypes: a?.marketType,
  };
};

export const transformApartment = (a: APIApartmentFull, isSavedInTemporaryFiles: boolean) => {
  return {
    ...transformApartmentItem(a),
    title: formatApartmentTitle(a.title),
    building: a.building,
    bedroomCount: a.bedroomCount,
    ceilingHeight: a.ceilingHeight,
    images: a.images.map((src) => ({ src, alt: `Изображение квартиры №${a.id}` })),
    isSavedInTemporaryFiles: isSavedInTemporaryFiles,
    originalFacilityId: a?.originalFacilityId,
    loweredPrice: a?.loweredPrice,
    hasMaternityCapital: a?.hasMaternityCapital,
    hasBurden: a?.hasBurden,
    minorOwners: a?.minorOwners,
    typeId: a?.typeId,
    platformAd: a?.platformAd,
  };
};

export const transformOneFilterNotification = (a: APIFilterNotificationItem) => {
  return {
    notification: {
      id: a.id,
      isEnabled: true,
    },
    id: a?.id,
    facilityId: a?.facility?.id,
    area: a?.facility?.areaInSqM,
    rooms: a?.facility?.roomCount,
    price: a?.facility?.price,
    isFavorite: a?.facility?.isFavorite,
    squarePrice: ~~a?.facility?.pricePerSqM,
    housingEstate: formatNullishValue(a?.facility?.apartmentComplexTitle),
    floor: { floor: a?.facility?.floor, total: a?.facility?.floorCount },
    image: a?.facility?.planImage ?? undefined,
    notificationEnabled: true,
    marketType: a?.facility?.marketType,
    title: a?.facility?.title,
    planImage: a?.facility?.planImage,
    attachment: a?.facility?.attachment,
    buildingTitle: a?.facility?.buildingTitle ?? '-',
    apartmentComplexTitle: a?.facility?.apartmentComplexTitle ?? '-',
  };
};
